import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-alerts',
  templateUrl: './feature-alerts.component.html',
  styleUrls: ['./feature-alerts.component.css']
})
export class FeatureAlertsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
